import React, {PropTypes} from "react";
import {Field, reduxForm} from "redux-form";
import {SelectField, TextField} from "redux-form-material-ui";
import MenuItem from "material-ui/MenuItem";
import Constants from "../../../classes/constants";


const validate = values => {
  const errors = {};
  const requiredFields = ['bank', 'accountNo','accountNo2', 'panNo', 'passportNo'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });
    if(values["accountNo"]!=values["accountNo2"])
    {
      errors["accountNo2"]="Kindly enter the same account no"
    }
  return errors
};


class FinanceInfoEdit extends React.Component {

  constructor() {
    super();
    this.state=({type: "text"})
  }

  render() {
    const {handleSubmit, reset} = this.props;
    var disabled = "";
    var style = {};
    if(this.props.editAccount == "false"){
      style = {display:"none"};
      disabled = "disabled";
    }
    else{
      disabled = "";
      style = {};
    }
    return (
      <div className="col-md-12">
        <form onSubmit={handleSubmit(data=> {
          console.log(data);
          this.props.submitHandler(data);

        })}>
          <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th cellPadding="0" colSpan="4">
                <span className="bold pull-left">Finance Info</span>
                <span className="bold hrms-link pull-right"><a type="submit">
                     <button type="submit"><i className="glyphicon glyphicon-saved"
                     ></i>Save</button></a></span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{align: 'left', width: '18%'}}>*Bank Name:</td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                  <Field
                    hintText="Bank Name"
                    name="bank"
                    component={SelectField}
                  >
                    <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
                    {Constants.vendorBank.map((vb) => {
                      return (
                        <MenuItem value={vb} primaryText={vb}/>);
                    })}
                  </Field>
                </span>
              </td>

              <td style={{align: 'left', width: '18%'}}>*IFSC No :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      hintText="IFSC No"
                      name="passportNo"
                      component={TextField}/></span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left',width: '18%'}}>*Pan No :</td>
              <td style={{align: 'left', width: '28%',padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText"><Field
                    hintText="Pan Number"
                    name="panNo"
                    component={TextField}/></span>
              </td>
              <td style={{align: 'left', width: '18%'}}>Aadhar No:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field
                      name="aadharNo"
                      hintText="Aadhar Card Number"
                      component={TextField}/></span>
              </td>
            </tr>

            <tr>
              <td style={{align: 'left', width: '18%'}}>*Account No :</td>
              <td style={{align: 'left',  width: '28%',padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                     <Field
                       onFocus={(event)=>{
                         this.setState({type: "text"})
                       }}
                       onBlur={(event)=>{
                         this.setState({type: "password"})
                       }}
                       type={this.state.type}
                       hintText="Bank Account Number"
                       name="accountNo"
                       component={TextField}
                       disabled = {disabled}
                     />
                  </span>
              </td>
              <td style={{align: 'left', width: '18%'}}>UAN:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      hintText="Employee UAN no"
                      name="empUAN"
                      component={TextField}/></span>
              </td>

            </tr>
              <tr style={style}>
                <td>*Reenter Account No :</td>
                <td>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                     <Field

                       hintText="Bank Account Number"
                       name="accountNo2"
                       component={TextField}/>
                  </span>
                </td>
              </tr>
          </tbody>
        </table>
      </form>
    </div>
    );
  }
}

FinanceInfoEdit.propTypes = {};

export default reduxForm({
  form: 'financeInfo',
  validate


})(FinanceInfoEdit)






/** WEBPACK FOOTER **
 ** ./src/components/joiningForm/Tables/FinanceInfoEdit.js
 **/